import { render, staticRenderFns } from "./Society.vue?vue&type=template&id=f349302a"
import script from "./Society.vue?vue&type=script&lang=js"
export * from "./Society.vue?vue&type=script&lang=js"
import style0 from "./Society.vue?vue&type=style&index=0&id=f349302a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports